import React from 'react';

const Privacy = () => {
  return (
    <div className="min-h-screen bg-white text-gray-800">
      <div className="max-w-3xl mx-auto px-6 py-12">
        <h1 className="text-3xl font-bold text-gray-900">Privacy Policy</h1>
        <p className="mt-2 text-sm text-gray-500">Last updated: {new Date().toLocaleDateString()}</p>

        <section className="mt-8 space-y-6 text-[15px] leading-7">
          <p>
            This Privacy Policy explains how Omabra collects, uses, and protects your information when you use Omabra Poultry Assistant ("Service").
          </p>

          <div>
            <h2 className="text-xl font-semibold text-gray-900">1. Information We Collect</h2>
            <ul className="mt-2 list-disc pl-6 space-y-2">
              <li>Account data: name, email, phone (optional), password (hashed).</li>
              <li>Farm data: records, activities, products, orders, and analytics you enter.</li>
              <li>Usage data: device/browser info, log data, cookies/local storage for authentication and preferences.</li>
            </ul>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-gray-900">2. How We Use Information</h2>
            <ul className="mt-2 list-disc pl-6 space-y-2">
              <li>Provide and improve the Service, including AI assistance and reminders.</li>
              <li>Communicate with you about your account, updates, and support.</li>
              <li>Protect the Service against abuse, fraud, and security threats.</li>
              <li>Analyze aggregated, anonymized usage to enhance features and performance.</li>
            </ul>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-gray-900">3. Legal Bases (where applicable)</h2>
            <ul className="mt-2 list-disc pl-6 space-y-2">
              <li>Contract: providing the Service.</li>
              <li>Legitimate interests: improving and securing the Service.</li>
              <li>Consent: sending certain communications; you can withdraw consent at any time.</li>
            </ul>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-gray-900">4. Sharing of Information</h2>
            <ul className="mt-2 list-disc pl-6 space-y-2">
              <li>Vendors and service providers (e.g., hosting, email, payments) under confidentiality obligations.</li>
              <li>Compliance with law, legal requests, or to protect rights, property, and safety.</li>
              <li>Business transfers in the event of a merger, acquisition, or asset sale.</li>
            </ul>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-gray-900">5. Data Security</h2>
            <p className="mt-2">We implement administrative, technical, and physical safeguards. No method is 100% secure; please use strong passwords and protect your account.</p>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-gray-900">6. Data Retention</h2>
            <p className="mt-2">We retain personal data while your account is active or as needed to provide the Service and meet legal obligations. You may request deletion subject to certain exceptions.</p>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-gray-900">7. Your Rights</h2>
            <ul className="mt-2 list-disc pl-6 space-y-2">
              <li>Access, update, or delete certain personal data via your profile or by contacting support.</li>
              <li>Object to or restrict certain processing where applicable by law.</li>
              <li>Data portability where applicable.</li>
            </ul>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-gray-900">8. International Transfers</h2>
            <p className="mt-2">Your data may be processed in countries with different data protection laws. We take steps to ensure appropriate safeguards.</p>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-gray-900">9. Children</h2>
            <p className="mt-2">The Service is not intended for children under 13. We do not knowingly collect data from children.</p>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-gray-900">10. Changes to this Policy</h2>
            <p className="mt-2">We may update this Policy. We will post the new version with an updated date. Continued use after changes means you accept the revised Policy.</p>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-gray-900">11. Contact</h2>
            <p className="mt-2">Questions or requests? Contact support@omabra.co.ke.</p>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Privacy;


